import React from 'react';
import CanvasWrapper from './components/CanvasWrapper';
import SinusParticleField from './components/particles/SinusParticleField';

const SplineScene: React.FC = () => (
    <CanvasWrapper>
        <SinusParticleField count={2000} />
    </CanvasWrapper>
);

export default SplineScene;